const { detectSupplier, parseSupplierInvoice } = require('./supplierInvoiceScan');

const MATCH_LABELS = {
  number: { text: 'Par # de pièce', className: 'label-success' },
  similarity: { text: 'Par description', className: 'label-warning' },
  none: { text: 'Aucune pièce', className: 'label-danger' },
};

function esc(value) {
  return $('<div>').text(value === undefined || value === null ? '' : String(value)).html();
}

function money(value) {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? `${parsed.toFixed(2)} $` : '';
}

function partText(number, name) {
  return `${String(number || '').trim() === '' ? '*vide*' : number} - ${name || ''}`;
}

function post(url, data) {
  return new Promise((resolve, reject) => {
    $.ajax({ url, type: 'POST', data, dataType: 'json', success: resolve, error: reject });
  });
}

function blockUI() {
  if (window.App && App.blockUI) {
    App.blockUI({ message: '<h1>Traitement en cours...<br>Veuillez patienter</h1>', boxed: true, zIndex: 20000 });
  }
}

function unblockUI() {
  if (window.App && App.unblockUI) {
    App.unblockUI();
  }
}

function xhrError(jqXHR, textStatus, thrownErr) {
  if (typeof window.processXHRError === 'function') {
    window.processXHRError(jqXHR, textStatus, thrownErr);
  } else {
    toastr.error('La requête a échoué.');
  }
}

// Open a server-rendered form in a nested dialog, like the part and supplier forms do
function openFormDialog(config) {
  blockUI();
  $.ajax({ url: config.url, type: 'POST', data: config.data || {}, dataType: 'html' })
    .done((html) => {
      unblockUI();
      const dialog = bootbox.dialog({
        message: html,
        title: config.title,
        className: config.className,
        size: config.size || 'medium',
        buttons: {
          save: {
            label: 'Enregistrer',
            className: 'purple',
            callback: function () {
              config.onSave(dialog);
              return false;
            },
          },
          cancel: { label: 'Annuler', className: 'btn' },
        },
      });
      if (config.onShown) {
        dialog.on('shown.bs.modal', () => config.onShown(dialog));
      }
    })
    .fail((jqXHR, textStatus, thrownErr) => {
      unblockUI();
      xhrError(jqXHR, textStatus, thrownErr);
    });
}

function submitForm(url, data, onDone) {
  blockUI();
  $.ajax({ url, type: 'POST', data, dataType: 'json' })
    .done((result) => {
      unblockUI();
      onDone(true, result);
    })
    .fail((jqXHR, textStatus, thrownErr) => {
      unblockUI();
      xhrError(jqXHR, textStatus, thrownErr);
      onDone(false);
    });
}

function renderModal(options) {
  return `
    <div class="rapid-supplier-invoice-modal-body">
      <div class="row">
        <div class="col-xs-12 col-md-4">
          <label class="control-label">Texte numérisé de la facture</label>
          <textarea class="form-control rsi-source" style="min-height: 260px; resize: vertical;" placeholder="Collez ici tout le texte de la facture numérisée"></textarea>
          <button type="button" class="btn btn-default btn-xs rsi-details-toggle" data-toggle="collapse" data-target="#rsi-details" aria-expanded="true" aria-controls="rsi-details">Masquer l’analyse</button>
        </div>
        <div class="col-xs-12 col-md-8 collapse in rsi-details" id="rsi-details">
          <div class="alert rsi-status" style="display:none; padding: 6px 10px; margin-bottom: 8px;"></div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label">Fournisseur</label>
                <div class="input-group select2-input-container">
                  <select class="form-control rsi-supplier" style="width: 100%;"></select>
                  <span class="input-group-btn">
                    ${options.can && options.can.supplierEdit ? '<button class="btn blue rsi-edit-supplier" type="button" tabindex="-1" title="Modifier le fournisseur"><i class="fa fa-edit"></i></button>' : ''}
                    ${options.can && options.can.supplierCreate ? '<button class="btn yellow rsi-add-supplier" type="button" tabindex="-1" title="Ajouter un fournisseur"><i class="fa fa-plus"></i></button>' : ''}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label">Numéro de facture</label>
                <input type="text" class="form-control rsi-number" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="control-label">Date</label>
                <input type="date" class="form-control rsi-date" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="control-label">% TPS</label>
                <input type="text" class="form-control rsi-tps" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label class="control-label">% TVQ</label>
                <input type="text" class="form-control rsi-tvq" />
              </div>
            </div>
          </div>
          <div class="table-responsive" style="max-height: 340px; overflow-y: auto;">
            <table class="table table-bordered table-condensed rsi-items" style="margin-bottom: 0;">
              <thead>
                <tr>
                  <th style="width: 30px;"></th>
                  <th>Valeur scannée</th>
                  <th style="width: 70px;">Qté</th>
                  <th style="width: 340px;">Pièce trouvée</th>
                  <th style="width: 90px;">Prix coûtant</th>
                  <th style="width: 90px;">Taxe pneu</th>
                </tr>
              </thead>
              <tbody>
                <tr><td colspan="6" class="text-muted">Aucune pièce analysée</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>`;
}

function openRapidSupplierInvoiceModal(options) {
  const baseEndpoint = options.baseEndpoint || '';
  const popup = bootbox.dialog({
    title: options.title || 'Importer une facture numérisée',
    message: renderModal(options),
    className: 'modal-rapid-supplier-invoice',
    size: 'large',
    buttons: {
      confirm: {
        label: 'Approuver et enregistrer',
        className: 'btn blue rsi-confirm',
        callback: function () {
          save();
          return false;
        },
      },
      cancel: {
        label: 'Annuler',
        className: 'btn',
      },
    },
  });

  popup.find('.modal-dialog').addClass('modal-xxlg');

  let templates = [];
  let defaults = { tps: '', tvq: '' };
  let rows = [];
  let analyzeSequence = 0;
  let analyzeTimer = null;
  let manualSupplierId = null;
  let saving = false;

  const source = popup.find('.rsi-source');
  const supplierSelect = popup.find('.rsi-supplier');
  const confirmButton = popup.find('.rsi-confirm');
  source.val(options.initialText || '');

  const details = popup.find('.rsi-details');
  const detailsToggle = popup.find('.rsi-details-toggle');
  if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) {
    details.collapse('hide');
    detailsToggle.attr('aria-expanded', 'false').text('Afficher l’analyse');
  }
  details.on('shown.bs.collapse', () => detailsToggle.attr('aria-expanded', 'true').text('Masquer l’analyse'));
  details.on('hidden.bs.collapse', () => detailsToggle.attr('aria-expanded', 'false').text('Afficher l’analyse'));

  function setStatus(message, type) {
    const status = popup.find('.rsi-status');
    if (!message) {
      status.hide().text('');
      return;
    }
    status.removeClass('alert-info alert-warning alert-danger alert-success').addClass(type || 'alert-info').html(message).show();
  }

  function needsNumberAssign(row) {
    return !!(row.part && String(row.part.number || '').trim() === '' && row.scan.part_number);
  }

  function updateConfirmState() {
    const importable = rows.filter((row) => row.include && row.part);
    confirmButton.prop('disabled', saving || importable.length === 0 || !supplierSelect.val());
  }

  function renderSupplierOptions(selectedId, selectedName) {
    supplierSelect.empty();
    if (selectedId) {
      const template = getTemplate(selectedId);
      supplierSelect.append(new Option(selectedName || (template ? template.supplier_name : String(selectedId)), String(selectedId), true, true));
    }
    supplierSelect.trigger('change.select2');
  }

  function getTemplate(supplierId) {
    return templates.find((t) => String(t.supplier_id) === String(supplierId)) || null;
  }

  function loadTemplates() {
    return $.getJSON(`${baseEndpoint}supplier_invoice/scan/templates`).then((result) => {
      templates = result.templates || [];
      defaults = { tps: result.default_tps, tvq: result.default_tvq };
    });
  }

  function onSupplierSaved(id, name) {
    manualSupplierId = String(id);
    loadTemplates().always(() => {
      renderSupplierOptions(id, name);
      analyze();
    });
  }

  function addSupplier() {
    openFormDialog({
      url: `${baseEndpoint}supplier/add`,
      title: 'Ajout d\'un fournisseur',
      className: 'modal-supplier',
      size: 'normal',
      onSave(dialog) {
        $('#form_supplier').validForm((onSuccess) => {
          submitForm(`${baseEndpoint}supplier/add/save`, { form: $('#form_supplier').serialize() }, (success, newId) => {
            if (success) {
              onSupplierSaved(newId, $('#form_supplier #supplier_name').val());
            }
            if (typeof window.processPopupServerResponse === 'function') {
              window.processPopupServerResponse(dialog, success);
            }
            onSuccess(success);
          });
        });
      },
    });
  }

  function editSupplier() {
    const supplierId = supplierSelect.val();
    if (!supplierId) {
      toastr.warning('Veuillez d\'abord choisir un fournisseur.');
      return;
    }
    openFormDialog({
      url: `${baseEndpoint}supplier/edit`,
      data: { id: supplierId },
      title: 'Modifier un fournisseur',
      className: 'modal-supplier',
      size: 'normal',
      onSave(dialog) {
        $('#form_supplier').validForm((onSuccess) => {
          submitForm(`${baseEndpoint}supplier/edit/save`, { id: supplierId, form: $('#form_supplier').serialize() }, (success) => {
            if (success) {
              onSupplierSaved(supplierId, $('#form_supplier #supplier_name').val());
            }
            if (typeof window.processPopupServerResponse === 'function') {
              window.processPopupServerResponse(dialog, success);
            }
            onSuccess(success);
          });
        });
      },
    });
  }

  function toRowPart(data) {
    return {
      id: data.part_id,
      number: data.part_number === '**vide**' ? '' : (data.part_number || ''),
      name: data.part_name || data.text || '',
      cost: data.part_cost_price,
      tire: data.part_tire_tax,
    };
  }

  // Apply a part chosen, created or edited, and check the row
  function applyPart(tr, row, part) {
    row.part = part;
    row.match_type = 'manual';
    row.include = true;
    const select = tr.find('select.rsi-part');
    select.empty().append(new Option(partText(part.number, part.name), part.id, true, true)).trigger('change.select2');
    refreshRow(tr, row);
  }

  function savePartResult(tr, row, result) {
    if (String(result.part_supplier_id) !== String(supplierSelect.val())) {
      toastr.warning('La pièce appartient à un autre fournisseur que celui de la facture; elle n\'a pas été sélectionnée.');
      return;
    }
    applyPart(tr, row, toRowPart(result));
  }

  function addPart(tr, row) {
    if (!supplierSelect.val()) {
      toastr.warning('Veuillez d\'abord choisir un fournisseur.');
      return;
    }
    openFormDialog({
      url: `${baseEndpoint}part/add`,
      title: 'Ajout d\'une pièce',
      className: 'modal-part',
      onShown() {
        $('#part_supplier_id').empty().append(new Option(supplierSelect.find('option:selected').text(), supplierSelect.val(), true, true)).trigger('change');
        $('#part_name').val(row.scan.description || row.scan.part_number || '');
        $('#part_number').val(row.scan.part_number || '');
      },
      onSave(dialog) {
        if (!$('#form_part').valid()) {
          return;
        }
        submitForm(`${baseEndpoint}part/add/save`, { form: $('#form_part').serialize(), from: 'select2' }, (success, result) => {
          if (success) {
            savePartResult(tr, row, result);
          }
          if (typeof window.processPopupServerResponse === 'function') {
            window.processPopupServerResponse(dialog, success);
          }
        });
      },
    });
  }

  function editPart(tr, row) {
    if (!row.part) {
      toastr.warning('Veuillez d\'abord choisir une pièce.');
      return;
    }
    const partId = row.part.id;
    openFormDialog({
      url: `${baseEndpoint}part/edit`,
      data: { id: partId },
      title: 'Modification d\'une pièce',
      className: 'modal-part',
      onSave(dialog) {
        if (!$('#form_part').valid()) {
          return;
        }
        submitForm(`${baseEndpoint}part/edit/save`, { id: partId, form: $('#form_part').serialize(), from: 'select2' }, (success, result) => {
          if (success) {
            savePartResult(tr, row, result);
          }
          if (typeof window.processPopupServerResponse === 'function') {
            window.processPopupServerResponse(dialog, success);
          }
        });
      },
    });
  }

  function renderRows() {
    const body = popup.find('.rsi-items tbody');
    body.find('select.rsi-part').each(function () {
      if ($(this).data('select2')) {
        $(this).select2('destroy');
      }
    });

    if (rows.length === 0) {
      body.html('<tr><td colspan="6" class="text-muted">Aucune pièce trouvée dans le texte</td></tr>');
      updateConfirmState();
      return;
    }

    body.html(rows.map((row, index) => {
      const label = MATCH_LABELS[row.match_type] || MATCH_LABELS.none;
      return `
        <tr data-index="${index}">
          <td class="text-center"><input type="checkbox" class="rsi-include" ${row.include ? 'checked' : ''} /></td>
          <td>
            <div><strong>${esc(row.scan.part_number) || '<span class="text-muted">(sans # de pièce)</span>'}</strong> ${esc(row.scan.description)}</div>
            <div class="text-muted" style="font-size: 11px; word-break: break-word;">${esc(row.scan.raw)}</div>
          </td>
          <td>
            <input type="text" class="form-control input-sm rsi-qty" value="${esc(row.qty)}" />
            ${row.scan.qty_estimated ? '<div class="text-muted" style="font-size: 11px;">estimée</div>' : ''}
          </td>
          <td>
            <div class="input-group select2-input-container">
              <select class="form-control rsi-part" style="width: 100%;"></select>
              <span class="input-group-btn">
                ${options.can && options.can.partEdit ? '<button class="btn blue rsi-edit-part" type="button" tabindex="-1" title="Modifier la pièce"><i class="fa fa-edit"></i></button>' : ''}
                ${options.can && options.can.partCreate ? '<button class="btn yellow rsi-add-part" type="button" tabindex="-1" title="Ajouter une pièce"><i class="fa fa-plus"></i></button>' : ''}
              </span>
            </div>
            <span class="label ${label.className} rsi-match-label">${label.text}${row.match_type === 'similarity' ? ` (${Math.round(row.score * 100)} %)` : ''}</span>
            <span class="text-muted rsi-assign-note" style="display:none; font-size: 11px; margin-left: 6px;">Le # scanné sera enregistré sur la pièce</span>
          </td>
          <td class="rsi-cost">${row.part ? esc(money(row.part.cost)) : ''}</td>
          <td class="rsi-tire">${row.part ? esc(money(row.part.tire)) : ''}</td>
        </tr>`;
    }).join(''));

    const dropdownParent = popup.closest('.bootbox.modal, .modal').length ? popup.closest('.bootbox.modal, .modal') : popup;

    body.find('tr[data-index]').each(function () {
      const tr = $(this);
      const row = rows[parseInt(tr.data('index'), 10)];
      const select = tr.find('select.rsi-part');

      if (row.part) {
        select.append(new Option(partText(row.part.number, row.part.name), row.part.id, true, true));
      }

      select.select2({
        language: 'fr',
        width: '100%',
        dropdownParent,
        placeholder: 'Chercher une pièce',
        allowClear: true,
        ajax: {
          url: `${baseEndpoint}part/select2/part_number_number`,
          dataType: 'json',
          delay: 250,
          data: (params) => ({
            search: params.term,
            page: params.page || 1,
            // Always restricted to the supplier of the invoice
            supplier_id: supplierSelect.val() || 0,
          }),
          processResults: (data) => {
            data.results.forEach((result) => {
              result.id = result.part_id;
            });
            return data;
          },
        },
        templateResult: (state) => {
          if (!state.id) {
            return 'Chargement des résultats...';
          }
          if (state.number === undefined || state.number === null) {
            return $(`<span>${esc(state.text)}</span>`);
          }
          return $(`<span class="margin-right-10">${esc(state.number)}</span><span class="bold small">${esc(state.supplier_name)} RT:${esc(state.part_return)} QT:${esc(state.part_inventory)}</span><br><span><small>${esc(state.name)}</small></span>`);
        },
        templateSelection: (state) => (state.number !== undefined && state.number !== null && state.number !== '' ? state.number : state.text),
      });

      select.on('select2:opening', (event) => {
        if (!supplierSelect.val()) {
          event.preventDefault();
          toastr.warning('Veuillez d\'abord choisir un fournisseur.');
        }
      });

      select.on('select2:select', (event) => {
        applyPart(tr, row, toRowPart(event.params.data));
      });

      select.on('select2:clear', () => {
        row.part = null;
        row.include = false;
        refreshRow(tr, row);
      });

      tr.find('.rsi-add-part').on('click', () => addPart(tr, row));
      tr.find('.rsi-edit-part').on('click', () => editPart(tr, row));

      refreshRow(tr, row);
    });

    updateConfirmState();
  }

  function refreshRow(tr, row) {
    tr.find('.rsi-include').prop('checked', !!row.include);
    tr.find('.rsi-cost').text(row.part ? money(row.part.cost) : '');
    tr.find('.rsi-tire').text(row.part ? money(row.part.tire) : '');
    tr.find('.rsi-assign-note').toggle(needsNumberAssign(row));
    if (row.match_type === 'manual') {
      tr.find('.rsi-match-label').attr('class', 'label label-info rsi-match-label').text('Choisie manuellement');
    } else if (!row.part) {
      tr.find('.rsi-match-label').attr('class', 'label label-danger rsi-match-label').text(MATCH_LABELS.none.text);
    }
    updateConfirmState();
  }

  async function analyze() {
    const sequence = ++analyzeSequence;
    const text = source.val();

    if (!text.trim()) {
      rows = [];
      setStatus('');
      renderRows();
      return;
    }

    let supplier = manualSupplierId ? getTemplate(manualSupplierId) : detectSupplier(text, templates);
    if (!supplier && !manualSupplierId && options.defaultSupplierId) {
      supplier = getTemplate(options.defaultSupplierId);
    }

    if (!supplier) {
      rows = [];
      setStatus(manualSupplierId
        ? 'Ce fournisseur n\'a pas de gabarit d\'import. Modifiez le fournisseur pour renseigner la section « Import de facture numérisée ».'
        : 'Aucun fournisseur reconnu. Choisissez un fournisseur ayant un gabarit d\'import (voir la fiche du fournisseur).', 'alert-warning');
      renderRows();
      return;
    }

    if (String(supplierSelect.val()) !== String(supplier.supplier_id)) {
      renderSupplierOptions(supplier.supplier_id, supplier.supplier_name);
    }
    const parsed = parseSupplierInvoice(text, supplier);

    popup.find('.rsi-number').val(parsed.number);
    popup.find('.rsi-date').val(parsed.date);
    popup.find('.rsi-tps').val(supplier.supplier_invoice_tps_value !== null && supplier.supplier_invoice_tps_value !== '' ? supplier.supplier_invoice_tps_value : defaults.tps);
    popup.find('.rsi-tvq').val(supplier.supplier_invoice_tvq_value !== null && supplier.supplier_invoice_tvq_value !== '' ? supplier.supplier_invoice_tvq_value : defaults.tvq);

    if (parsed.errors.length > 0) {
      setStatus(parsed.errors.join('<br>'), 'alert-danger');
    } else if (parsed.items.length === 0) {
      setStatus(`Fournisseur reconnu: <strong>${esc(supplier.supplier_name)}</strong>, mais aucune pièce n'a été trouvée. Vérifiez le gabarit du fournisseur.`, 'alert-warning');
    } else {
      setStatus(`Fournisseur reconnu: <strong>${esc(supplier.supplier_name)}</strong> — ${parsed.items.length} pièce(s) trouvée(s). Vérifiez les correspondances avant d'enregistrer.`, 'alert-info');
    }

    let matches = [];
    try {
      matches = await post(`${baseEndpoint}supplier_invoice/scan/match`, {
        supplier_id: supplier.supplier_id,
        items: JSON.stringify(parsed.items.map((item) => ({ part_number: item.part_number, description: item.description }))),
      });
    } catch (e) {
      setStatus('Impossible de chercher les pièces correspondantes.', 'alert-danger');
    }

    if (sequence !== analyzeSequence) {
      return;
    }

    rows = parsed.items.map((item, index) => {
      const match = matches[index] || { part: null, match_type: 'none', score: 0 };
      const part = match.part ? {
        id: match.part.part_id,
        number: match.part.part_number,
        name: match.part.part_name,
        cost: match.part.part_cost_price,
        tire: match.part.part_tire_tax,
      } : null;

      return {
        scan: item,
        qty: item.qty,
        part,
        match_type: match.match_type,
        score: match.score,
        include: !!part,
      };
    });
    renderRows();
  }

  async function save() {
    const importable = rows.filter((row) => row.include && row.part);
    if (saving || importable.length === 0) {
      return;
    }

    saving = true;
    updateConfirmState();
    confirmButton.text('Enregistrement...');

    const data = {
      supplier_id: supplierSelect.val(),
      number: popup.find('.rsi-number').val(),
      date: popup.find('.rsi-date').val(),
      tps: popup.find('.rsi-tps').val().replace(',', '.'),
      tvq: popup.find('.rsi-tvq').val().replace(',', '.'),
      scanned_text: source.val(),
      items: importable.map((row) => ({
        part_id: row.part.id,
        qty: String(row.qty).replace(',', '.'),
        assign_part_number: needsNumberAssign(row) ? row.scan.part_number : '',
      })),
    };

    try {
      await post(`${baseEndpoint}supplier_invoice/scan/import`, { id: options.supplierInvoiceId, data: JSON.stringify(data) });
      popup.modal('hide');
      toastr.success('La facture numérisée a été importée.');
      if (typeof options.onSaved === 'function') {
        options.onSaved();
      }
    } catch (e) {
      saving = false;
      confirmButton.text('Approuver et enregistrer');
      updateConfirmState();
      toastr.error('Impossible d\'enregistrer la facture numérisée.');
    }
  }

  source.on('input paste', () => {
    clearTimeout(analyzeTimer);
    analyzeTimer = setTimeout(analyze, 400);
  });

  supplierSelect.select2({
    language: 'fr',
    width: '100%',
    dropdownParent: popup,
    placeholder: 'Choisir un fournisseur',
    allowClear: true,
    ajax: {
      url: `${baseEndpoint}part/select2/part_supplier_id`,
      dataType: 'json',
      data: (params) => ({ search: params.term, page: params.page || 1 }),
      processResults: (data) => data,
    },
    templateResult: (state) => (state.id ? $(`<span>${esc(state.name || state.text)}</span>`) : 'Chargement des résultats...'),
  });

  // Only user choices change the supplier; programmatic updates go through renderSupplierOptions
  supplierSelect.on('select2:select select2:clear', () => {
    manualSupplierId = supplierSelect.val() || null;
    analyze();
  });

  popup.on('change', '.rsi-include', function () {
    rows[parseInt($(this).closest('tr').data('index'), 10)].include = this.checked;
    updateConfirmState();
  });

  popup.on('input change', '.rsi-qty', function () {
    rows[parseInt($(this).closest('tr').data('index'), 10)].qty = $(this).val();
  });

  popup.on('click', '.rsi-add-supplier', addSupplier);
  popup.on('click', '.rsi-edit-supplier', editSupplier);

  updateConfirmState();
  popup.on('shown.bs.modal', () => source.trigger('focus'));

  loadTemplates()
    .done(() => {
      const initial = options.defaultSupplierId ? getTemplate(options.defaultSupplierId) : null;
      if (initial && !supplierSelect.val()) {
        renderSupplierOptions(initial.supplier_id, initial.supplier_name);
      }
      if (source.val().trim()) {
        analyze();
      }
    })
    .fail(() => setStatus('Impossible de charger les gabarits des fournisseurs.', 'alert-danger'));

  return popup;
}

async function quickImportSupplierInvoice(options) {
  const baseEndpoint = options.baseEndpoint || '';
  const button = options.button ? $(options.button) : $();
  const text = String(options.text || '');

  if (!text.trim()) {
    toastr.warning('Collez d’abord le texte numérisé de la facture.');
    return;
  }

  button.prop('disabled', true);
  blockUI();

  try {
    const templateResponse = await $.getJSON(`${baseEndpoint}supplier_invoice/scan/templates`);
    const templates = templateResponse.templates || [];
    const supplier = detectSupplier(text, templates)
      || templates.find((template) => String(template.supplier_id) === String(options.defaultSupplierId));

    if (!supplier) {
      toastr.warning('Aucun fournisseur reconnu. Vérifiez le gabarit du fournisseur.');
      return;
    }

    const parsed = parseSupplierInvoice(text, supplier);
    if (parsed.errors.length) {
      toastr.error(parsed.errors.join(' '));
      return;
    }

    const matches = parsed.items.length
      ? await post(`${baseEndpoint}supplier_invoice/scan/match`, {
        supplier_id: supplier.supplier_id,
        items: JSON.stringify(parsed.items.map((item) => ({
          part_number: item.part_number,
          description: item.description,
        }))),
      })
      : [];
    const items = parsed.items.reduce((matched, item, index) => {
      const part = matches[index] && matches[index].part;
      if (!part || !part.part_id) {
        return matched;
      }

      const partNumber = String(part.part_number === '**vide**' ? '' : (part.part_number || '')).trim();
      matched.push({
        part_id: part.part_id,
        qty: String(item.qty).replace(',', '.'),
        assign_part_number: partNumber === '' && item.part_number ? item.part_number : '',
      });
      return matched;
    }, []);

    const supplierTax = (field, fallback) => supplier[field] !== undefined && supplier[field] !== null && supplier[field] !== ''
      ? supplier[field]
      : (fallback !== undefined && fallback !== null && fallback !== '' ? fallback : '');
    const data = {
      supplier_id: supplier.supplier_id,
      number: parsed.number,
      date: parsed.date,
      tps: String(supplierTax('supplier_invoice_tps_value', templateResponse.default_tps)).replace(',', '.'),
      tvq: String(supplierTax('supplier_invoice_tvq_value', templateResponse.default_tvq)).replace(',', '.'),
      scanned_text: text,
      verified: 0,
      items,
    };

    await post(`${baseEndpoint}supplier_invoice/scan/import`, {
      id: options.supplierInvoiceId,
      data: JSON.stringify(data),
    });

    if (items.length) {
      toastr.success(`${items.length} pièce(s) correspondante(s) importée(s).`);
    } else {
      toastr.warning('Aucune pièce correspondante; le texte numérisé et les renseignements détectés ont été enregistrés.');
    }
    if (typeof options.onSaved === 'function') {
      options.onSaved();
    }
  } catch (error) {
    toastr.error('Impossible d’analyser ou d’enregistrer la facture numérisée.');
  } finally {
    unblockUI();
    button.prop('disabled', false);
  }
}

module.exports = {
  openRapidSupplierInvoiceModal,
  quickImportSupplierInvoice,
};
